import React from 'react';
import { useNavigate } from 'react-router-dom';

function BlogPage() {
  const navigate = useNavigate();

  const blogPosts = [
    {
      title: "2025 Yılı Yatırım Stratejileri",
      excerpt: "Yeni yılda yatırımcıların dikkat etmesi gereken önemli noktalar ve stratejiler...",
      date: "15 Ocak 2025"
    },
    {
      title: "VİOP Piyasasında Başarının Sırları",
      excerpt: "Vadeli işlemler ve opsiyon piyasalarında başarılı olmak için bilinmesi gerekenler...",
      date: "10 Ocak 2025"
    },
    {
      title: "Forex Piyasasına Giriş Rehberi",
      excerpt: "Döviz piyasalarında işlem yapmaya başlamadan önce bilmeniz gerekenler...",
      date: "5 Ocak 2025"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Blog</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-5xl mx-auto py-12 px-4">
        <div className="space-y-6">
          {blogPosts.map((post, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow cursor-pointer">
              <h2 className="text-xl md:text-2xl font-bold text-[#1e5a8e] mb-3">
                {post.title}
              </h2>
              <p className="text-gray-600 mb-4">{post.excerpt}</p>
              <p className="text-gray-400 text-sm">{post.date}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogPage;
